import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { keysToCamelCase } from '@/shared/services/tools';

import { reportsApi } from '../api/reports.api';
import type {
  ITemplateDto,
  TTemplate
} from '../pages/Reports/types/reports.types';

export const getTemplates = createAsyncThunk(
  'templates/getTemplates',
  async () => {
    return await reportsApi.getTemplates();
  }
);

export const redactTemplate = createAsyncThunk(
  'templates/redactTemplate',
  async (
    data: { templateId: string; template: ITemplateDto },
    { dispatch }
  ) => {
    const response = await reportsApi.redactTemplate(
      data.templateId,
      data.template
    );
    dispatch(getTemplates());
    return response;
  }
);

export const createTemplate = createAsyncThunk(
  'templates/createTemplate',
  async (data: ITemplateDto, { dispatch }) => {
    const response = await reportsApi.createTemplate(data);
    dispatch(getTemplates());
    return response;
  }
);

interface IAdminReportsState {
  templates: TTemplate[];
}

const initialState: IAdminReportsState = {
  templates: []
};

const adminReportsSlice = createSlice({
  name: 'adminReports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTemplates.fulfilled, (state, action) => {
      state.templates = keysToCamelCase(action.payload);
    });
  }
});

export default adminReportsSlice;
